import React, { useEffect, useState } from 'react';
import '../css/navBar.css';
import '../css/registro.css';
import EncabezadoAdminN from './EncabezadoAdminN';
import TablaAdmin from './TablaAdmin';
import ModalCodigo from './ModalCodigo';
import ModalRecuperar from './ModalRecuperar';
import { TablaAxios } from './TablaAxios';
import { ControlPanel } from './ControlPanel';
import { EmpresasAdminN } from './EmpresasAdminN';
import { EventsAdmin } from './EventsAdmin';
import { MeetingsAdmin } from './MeetingsAdmin';

function MainAdmin2(props) {
    const [nombreBuscar, setNombreBuscar] = useState('');
    const [evento, setEvento] = useState({ nombre: '' });
    const [showedModals, setShowedModals] = useState([]);

    return (
        <>
            <div id="containerAdminN" className='container bg-white pb-5 px-5 position-relative containerMainAdm' >{/*containerRegistro*/}
                {props.seccion !== "panel" && (<EncabezadoAdminN seccion={props.seccion} setNombreBuscar={setNombreBuscar} setEvento={setEvento}
                    setShowedModals={setShowedModals} showedModals={showedModals} nombreBuscar={nombreBuscar} />)}
                {/* nombreBuscar={nombreBuscar} evento={evento}*/}
                {props.seccion === "panel" ? (
                    <ControlPanel />
                ) : props.seccion === "crearEvento" ? (
                    <>
                        {/* <TablaAdmin seccion={props.seccion} nombreBuscar={nombreBuscar} setNombreBuscar={setNombreBuscar} evento={evento} />*/}
                        <EventsAdmin search={nombreBuscar} setNombreBuscar={setNombreBuscar} evento={evento}
                            setShowedModals={setShowedModals} showedModals={showedModals} />
                        {/*
                    <Tabla seccionId={1} esAdmin={true}/>*/}
                    </>
                ) : props.seccion === "aprobarEmpresa" ? (
                    <>
                        {/*<TablaAdmin seccion={props.seccion} />*/}
                        <EmpresasAdminN search={nombreBuscar} setShowedModals={setShowedModals}/>
                        {/*<Tabla seccionId={2} esAdmin={true}/>*/}
                    </>
                ) : props.seccion === "configuracion" ? (
                    <>
                        <TablaAxios url={'empresa/getAllRubros'} itemsEncabezado={[{ className: 'col text-center', text: 'Rubros' }]}
                            id={'containerRubros'} elemNoEncontrado={'rubros'} />
                        <TablaAxios url={'empresa/getAllUnionesIndustriales'} itemsEncabezado={[{ className: 'col text-center', text: 'Uniones industriales' }]}
                            id={'containerUniones'} elemNoEncontrado={'uniones industriales'} classNameTabla={'d-none'} />
                        <ModalCodigo />
                        <ModalRecuperar />
                        {/*<Tabla seccionId={2} esAdmin={true}/>*/}
                    </>
                ) : props.seccion === "crearReunion" ? (
                    <>
                        {/*<TablaAdmin seccion={props.seccion} evento={evento} />*/}
                        <MeetingsAdmin seccion={props.seccion} evento={evento} showedModals={showedModals} setShowedModals={setShowedModals}/>
                        {/*<Tabla seccionId={2} esAdmin={true}/>*/}
                    </>
                ) : <></>
                }
            </div>
        </>
    );
}


export default MainAdmin2;